export default class CampaignListModel {
  constructor (data) {
    this.id = data.id
    this.name = data.name
    this.value = data.name
    this.email = data.email
    this.endDate = data.endDate
    this.startDate = data.startDate
    this.surveyId = data.surveyId
  }
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/CampaignListModel.js